export class LpmConfig {
    scope : LpmScope = 'EXT' ;  // EXT (external/bridge user) or LPM
    allowRename : boolean = true;
    host : 'LollyLaw' | 'PracticePanther' = null;
    allowCopy : boolean = true;
    allowMove : boolean = true;
    allowPreview : boolean = true;
    allowEdit : boolean = true;
    allowShare : boolean = true;
    isExternalShareSupported: boolean = true;
    isInternalShareSupported: boolean = true;
    viewPermissions : boolean = true;
    showTrashPageTitle : boolean = true;
    allowTrash : boolean = true;
    emptyTrashButtonWithLabel : boolean = false;
    allowStar : boolean = true;
    allowLabel : boolean = true;
    allowLock : boolean = true;
    organizeFavorite : boolean = true;
    organizeLabel : boolean = true;
    viewInfoDetails : boolean = true;
    viewActivityDetails : boolean = true;
    viewNotesDetails : boolean = true;
    filterByLabel : boolean = true;
    filterByTrash : boolean = true;
    filterByFavorite : boolean = true;
    allowAddNotes : boolean = true;
    viewNotes : boolean = true;
    isUserTaggingSupported : boolean = true;
    deleteLabelText : string = 'Trash';
    trashLocationLabel : string = 'Trash';
    shareModalTitle : string = 'Share';
    externalShareSelectLabel : string = 'Select Users';
    externalShareInstructions : string = 'Enter email and manage access level';
    externalShareWriterRoleLabel : string = 'WRITER';
    externalShareViewerRoleLabel : string = 'VIEWER'; 
    allowDownload : boolean = true;
    allowOpenOnDesktop : boolean = true;
    downloadConfirmButtonIcon : boolean = false;
    fullExplorer : boolean = false;
    isSupportUser: boolean = false;
    globalUploadPopup: boolean = false;
    isFileNameRequiredInGlobalSearch: boolean = true;
    fixedExternalList: boolean = false;
    copilotConfig: LpmCopilotConfig = new LpmCopilotConfig();
    supportEmail?: string = null;
    supportMessage?: string = null;
    clientUploadsFolderId: string = null;
}

export class LpmCopilotConfig {
    contactIds: number[] = [];
    matterId: number = null;
}

export type LpmScope = 'EXT' | 'LPM' ;  // EXT (external/bridge user) or LPM